const BASE_URL_FRONT_HOST = process.env.REACT_APP_BASE_URL_FRONT_HOST

export default function useNavigationApp() {

  // Fonction helper pour naviguer depuis une iframe
  const navigateFromIframe = (url: string, action: string) => {
    try {
      // Tentative de navigation directe (peut échouer à cause des restrictions CORS)
      window.parent.location.href = url
      console.log(`${action} (iframe direct) ::`, url)
    } catch (error) {
      // Si la navigation directe échoue, utilise postMessage
      console.log(`${action} (iframe postMessage) ::`, url)
      window.parent.postMessage({
        type: 'NAVIGATE',
        url: url,
        action: action
      }, '*') // En production, remplacez '*' par l'origine spécifique de votre app host
      
      // Fallback : ouvre dans un nouvel onglet si postMessage ne fonctionne pas
      setTimeout(() => {
        window.open(url, '_top')
      }, 1000)
    }
  }

 const goToHome = () => {
    const url = `${BASE_URL_FRONT_HOST}/`
    // Vérifie si l'app est dans une iframe
    if (window.parent && window.parent !== window) {
      navigateFromIframe(url, 'goToHome')
    } else {
      // Si pas dans une iframe, navigation normale
      window.location.href = url
      console.log("goToHome (direct) ::", url)
    }
 }

 const goToLogin = () => {
    const url = `${BASE_URL_FRONT_HOST}/login`
    if (window.parent && window.parent !== window) {
      navigateFromIframe(url, 'goToLogin')
    } else {
      window.location.href = url
      console.log("goToLogin (direct) ::", url)
    }
 }

 const goToResetPasswordRequest = () => {
    const url = `${BASE_URL_FRONT_HOST}/reset-password-request`
    if (window.parent && window.parent !== window) {
      navigateFromIframe(url, 'goToResetPasswordRequest')
    } else {
      window.location.href = url
      console.log("goToResetPasswordRequest (direct) ::", url)
    }
 }

 const goToCreateSpendingFromDemand = (spendingDemandId: string, spendingDemandName?: string, spendingDemandAmount?: number, spendingDemandAmountTTC?: number, spendingDemandDesc?: string) => {
    let url = `${BASE_URL_FRONT_HOST}/admin/spendings?new=true&spending_demand_id=${spendingDemandId}`
    if (spendingDemandName) {
      url += `&spending_demand_name=${encodeURIComponent(spendingDemandName)}`
    }
    if (spendingDemandDesc) {
      url += `&spending_demand_desc=${encodeURIComponent(spendingDemandDesc)}`
    }
    if (spendingDemandAmount !== undefined && spendingDemandAmount !== null) {
      url += `&spending_demand_amount=${spendingDemandAmount}`
    }
    if (spendingDemandAmountTTC !== undefined && spendingDemandAmountTTC !== null) {
      url += `&spending_demand_amountTTC=${spendingDemandAmountTTC}`
    }
    if (window.parent && window.parent !== window) {
      navigateFromIframe(url, 'goToCreateSpendingFromDemand')
    } else {
      window.location.href = url
      console.log("goToCreateSpendingFromDemand (direct) ::", url)
    }
 }

 const goToCreateSpendingFromDemandUser = (spendingDemandId: string, spendingDemandName?: string, spendingDemandAmount?: number, spendingDemandAmountTTC?: number, spendingDemandDesc?: string) => {
  let url = `${BASE_URL_FRONT_HOST}/spendings?new=true&spending_demand_id=${spendingDemandId}`
  if (spendingDemandName) {
    url += `&spending_demand_name=${encodeURIComponent(spendingDemandName)}`
  }
  if (spendingDemandDesc) {
    url += `&spending_demand_desc=${encodeURIComponent(spendingDemandDesc)}`
  }
  if (spendingDemandAmount !== undefined && spendingDemandAmount !== null) {
    url += `&spending_demand_amount=${spendingDemandAmount}`
  }
  if (spendingDemandAmountTTC !== undefined && spendingDemandAmountTTC !== null) {
    url += `&spending_demand_amountTTC=${spendingDemandAmountTTC}`
  }
  if (window.parent && window.parent !== window) {
    navigateFromIframe(url, 'goToCreateSpendingFromDemand')
  } else {
    window.location.href = url
    console.log("goToCreateSpendingFromDemand (direct) ::", url)
  }
}


 const goToCreateCreditFromDemand = (spendingDemandId: string | string[], spendingDemandName?: string | string[], creditsForUserId?: string) => {
    // Convertir en tableau si c'est une string, puis joindre avec des virgules
    const spendingDemandIds = Array.isArray(spendingDemandId) 
      ? spendingDemandId.join(',') 
      : spendingDemandId;
    
    let url = `${BASE_URL_FRONT_HOST}/admin/credits?new=true&spending_demand_id=${spendingDemandIds}`
    if (spendingDemandName) {
      // Convertir en tableau si c'est une string, puis joindre avec des virgules
      const spendingDemandNames = Array.isArray(spendingDemandName)
        ? spendingDemandName.join(',')
        : spendingDemandName;
      url += `&spending_demand_name=${encodeURIComponent(spendingDemandNames)}`
    }
    if (creditsForUserId) {
      url += `&credits_for_user_id=${creditsForUserId}`
    }
    if (window.parent && window.parent !== window) {
      navigateFromIframe(url, 'goToCreateCreditFromDemand')
    } else {
      window.location.href = url
      console.log("goToCreateCreditFromDemand (direct) ::", url)
    }
 }

 const goToSpending = (spendingId: string) => {
    const url = `${BASE_URL_FRONT_HOST}/admin/spendings?spending_id=${spendingId}`
    if (window.parent && window.parent !== window) {
      navigateFromIframe(url, 'goToSpending')
    } else {
      window.location.href = url
      console.log("goToSpending (direct) ::", url)
    }
 }

 const goToSpendingUser = (spendingId: string) => {
    const url = `${BASE_URL_FRONT_HOST}/spendings?spending_id=${spendingId}`
    if (window.parent && window.parent !== window) {
      navigateFromIframe(url, 'goToSpendingUser')
    } else {
      window.location.href = url
      console.log("goToSpendingUser (direct) ::", url)
    }
 }

 const goToCredit = (creditId: string) => {
    const url = `${BASE_URL_FRONT_HOST}/admin/credits?credit_id=${creditId}`
    if (window.parent && window.parent !== window) {
      navigateFromIframe(url, 'goToCredit')
    } else {
      window.location.href = url
      console.log("goToCredit (direct) ::", url)
    }
 }

  return {
    goToHome,
    goToLogin,
    goToResetPasswordRequest,
    goToCreateSpendingFromDemand,
    goToCreateCreditFromDemand,
    goToCreateSpendingFromDemandUser,
    goToSpending,
    goToSpendingUser,
    goToCredit
  }
}
